export default "__VITE_ASSET__CgDX_wRK__"